import React from "react";
import { getWindow } from "ssr-window";
import i18n from "i18next";

import { api } from "@/utils/api";
import { setUrlParameter } from "@/utils";
import InformationItem from "@/react-components/InformationItem";
import EmptyResult from "@/react-components/EmptyResult";
import Pagination from "@/react-components/Pagination";
import BackButton from "@/react-components/BackButton";

class InformationSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageParams: {
        pageNo: getWindow()?.history?.state?.params?.pageNo || 1,
        pageSize: 15,
        totalPage: 1,
      },
      list: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { pageParams } = this.state;
    const state = getWindow()?.history?.state || {};
    state.params = pageParams;
    getWindow().history.replaceState(state, "");
    api.information
      .getList({
        currentPage: pageParams.pageNo,
        pagePartCount: pageParams.pageSize,
      })
      .then((response) => {
        if (response?.newsInfoList?.length > 0) {
          const itemIds = response?.newsInfoList?.map(
            (item) => item.newsDataInfo?.newsId
          );
          api.information
            .getDetail(null, {
              itemIds,
            })
            .then((response1) => {
              const list = response?.newsInfoList?.map((item) => ({
                ...item.newsDataInfo,
                detailLink: response1.find(
                  (item1) => item.newsDataInfo.newsId === item1.newsId
                )?.detailLink,
              }));
              pageParams.totalPage = parseInt(
                (response.newsTotalNum + pageParams.pageSize - 1) /
                  pageParams.pageSize
              );
              this.setState({
                pageParams,
                list,
              });
              setUrlParameter({
                page: pageParams.pageNo,
              });
            })
            .catch((error) => {
              console.error("error: " + error.message);
            });
        } else {
          this.setState({
            list: [],
          });
          setUrlParameter({ type: "noResult" });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  pageChange = (page) => {
    const { pageParams } = this.state;
    pageParams.pageNo = page;
    this.setState({ pageParams }, () => {
      this.fetchData();
    });
  };

  render() {
    const {
      list,
      pageParams: { totalPage, pageNo },
    } = this.state;

    return (
      <section>
        <BackButton />
        <h3 className="page-title-text information-page-title">
          {i18n.t("TCCs0032_information_info_title")}
        </h3>
        {list && (
          <React.Fragment>
            <div>
              {list.map((item, index) => (
                <InformationItem key={index} data={item} />
              ))}
            </div>
            {list.length > 0 ? (
              <div className="pagination-container information-pagination-container">
                <Pagination
                  totalPage={totalPage}
                  pageIndex={pageNo}
                  onChange={this.pageChange}
                />
              </div>
            ) : (
              <EmptyResult text={i18n.t("TCCs0032_empty_text")} />
            )}
          </React.Fragment>
        )}
      </section>
    );
  }
}

export default InformationSection;
